export const GET_FONT_TYPE_DATA: string = "GET_FONT_TYPE_DATA";
export const GET_FONT_TYPE_DATA_SUCCESS: string = "GET_FONT_TYPE_DATA_SUCCESS";
export const GET_FONT_TYPE_DATA_FAIL: string = "GET_FONT_TYPE_DATA_FAIL";
export const RESET_FONT_TYPE_DATA: string = "RESET_FONT_TYPE_DATA";
export const SET_FONT_TYPE: string = "SET_FONT_TYPE";
export const SET_FONT_TYPE_SUCCESS: string = "SET_FONT_TYPE_SUCCESS";
export const SET_FONT_TYPE_FAIL: string = "SET_FONT_TYPE_FAIL";
